<div class="grid-widget">
  @if (widgetTitle) {
    <div class="widget-title-header">
      <div class="widget-title-content">
        <i class="material-icons widget-view-icon"
          [title]="viewIcon === 'default' ? 'Default View' : (viewIcon === 'shared' ? 'Shared View' : 'Personal View')">
          {{ viewIcon === 'default' ? 'auto_awesome' : (viewIcon === 'shared' ? 'group' : 'person') }}
        </i>
        <h4 class="widget-title">{{ titleMeta.isCustom ? widgetTitle : (widgetTitle | translate) }}{{ titleMeta.tailPrefix }}{{ titleMeta.tailKey | translate }}{{ titleMeta.tail }}</h4>
      </div>
    </div>
  }
  @if (widgetTitle) {
    <hr class="widget-divider">
  }
  <div class="widget-content" #sampleListContainer></div>
</div>